import * as React from 'react';
import { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.125 5.063a3.938 3.938 0 1 1 7.875 0 3.938 3.938 0 0 1-7.875 0Zm7.098 3.955a5.063 5.063 0 1 1 .795-.796l2.442 2.443a.562.562 0 1 1-.795.795L8.223 9.018Z"
      fill="#currentColor"
    />
  </svg>
);

export default SvgSearch;
